/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cl_Affects_ItemsInputs */

const en_cl_affects_items = /** @type {(inputs: Cl_Affects_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Items with their own detected or chosen language keep it. The rest follow the product.`)
};

const de_cl_affects_items = /** @type {(inputs: Cl_Affects_ItemsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elemente mit eigener erkannter oder gewählter Sprache behalten sie. Alle anderen folgen dem Produkt.`)
};

/**
* | output |
* | --- |
* | "Items with their own detected or chosen language keep it. The rest follow the product." |
*
* @param {Cl_Affects_ItemsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cl_affects_items = /** @type {((inputs?: Cl_Affects_ItemsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cl_Affects_ItemsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_cl_affects_items(inputs)
	return en_cl_affects_items(inputs)
});